import { Injectable } from '@angular/core';

@Injectable()
export class UtilsService {
    separator = '#';

    constructor() { }

    pad ( _s: number) {
        return (_s < 10) ? '0' + _s : _s;
    }

    // merge icon and designation
    mergeString ( _designation, _icon ): string {
        return _designation + this.separator + _icon;
    }

    // extract icon from designation text
    extractIcon(_text: string): string {
        let _array = new Array ();
        let result = '';

        if ( _text ) {
            _array = _text.split(this.separator);
        }

        if (_array.length > 1) {
            result = _array[1];
        }
        return result;
    };

    // extract designation
    extractDesignation(_text: string): string {
        let _array = new Array ();

        if ( _text ) {
            _array = _text.split(this.separator);
            return _array[0];
        }
    };

    ConvertToDate ( _d: Date ) {
        return [this.pad(_d.getDate()), this.pad(_d.getMonth() + 1), _d.getFullYear()].join('/');
    }

    ConvertToTime ( _d: Date ) {
        return [this.pad(_d.getHours()), this.pad(_d.getMinutes())].join(':');
    }
}



// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/service/utils.service.ts